(() => {
  const dialog = document.querySelector("[data-storitime-wishlist-dialog]");
  const entriesRoot = dialog?.querySelector("[data-storitime-wishlist-entries]");
  const status = dialog?.querySelector("[data-storitime-wishlist-status]");
  const close = dialog?.querySelector("[data-storitime-close-wishlist]");
  const tokenKey = "storitime-commerce-guest-wishlist-token";
  let returnFocus = null;
  let mergedGuestToken = null;

  if (!dialog || !entriesRoot || !status) return;

  const request = async (path, method, payload) => {
    const options = { method, headers: { "content-type": "application/json" } };
    if (payload) options.body = JSON.stringify(payload);
    const response = await fetch(`/apps/storitime${path}`, options);
    const result = await response.json().catch(() => ({}));
    if (!response.ok || !result.ok) throw new Error(result.error || "request_failed");
    return result;
  };

  const writeGuestToken = (value) => value && localStorage.setItem(tokenKey, value);
  const guestPayload = () => ({ guestToken: localStorage.getItem(tokenKey) || undefined });
  const mergeGuestWishlistOnce = async () => {
    const guestToken = localStorage.getItem(tokenKey);
    if (!guestToken || guestToken === mergedGuestToken) return;
    mergedGuestToken = guestToken;
    try {
      await request("/wishlist", "POST", { action: "merge", guestToken });
    } catch {
      // Signed Shopify customers merge server-side. Guests remain private to the token.
    }
  };

  const productPath = (entry) => {
    const handle = String(entry.productHandle || "").replace(/^\/+/, "");
    const variant = entry.shopifyVariantId ? `?variant=${encodeURIComponent(entry.shopifyVariantId)}` : "";
    return handle ? `/products/${encodeURIComponent(handle)}${variant}` : "/";
  };

  const showWishlist = async (trigger, openDialog = true) => {
    if (trigger) returnFocus = trigger;
    status.textContent = "Loading saved items…";
    entriesRoot.replaceChildren();
    if (openDialog && !dialog.open) dialog.showModal();
    try {
      await mergeGuestWishlistOnce();
      const result = await request("/wishlist", "POST", { action: "list", ...guestPayload() });
      writeGuestToken(result.guestToken);
      const entries = result.entries || [];
      status.textContent = entries.length ? `${entries.length} saved ${entries.length === 1 ? "item" : "items"}.` : "No saved items yet.";
      entries.forEach((entry) => {
        const item = document.createElement("article");
        item.className = "storitime-wishlist-item";
        if (entry.productImageUrl) {
          const image = document.createElement("img");
          image.className = "storitime-wishlist-item__image";
          image.src = entry.productImageUrl;
          image.alt = "";
          image.loading = "lazy";
          item.append(image);
        }
        const content = document.createElement("div");
        content.className = "storitime-wishlist-item__content";
        const title = document.createElement("p");
        title.className = "storitime-wishlist-item__title";
        title.textContent = entry.productTitle || "STORITIME item";
        const visit = document.createElement("a");
        visit.className = "storitime-wishlist-item__link";
        visit.href = productPath(entry);
        visit.textContent = "VIEW ITEM";
        const remove = document.createElement("button");
        remove.type = "button";
        remove.className = "storitime-wishlist-item__remove";
        remove.textContent = "REMOVE";
        remove.addEventListener("click", async () => {
          remove.disabled = true;
          try {
            const outcome = await request("/wishlist", "POST", { action: "remove", entryId: entry.id, ...guestPayload() });
            writeGuestToken(outcome.guestToken);
            await showWishlist(null, false);
          } catch {
            status.textContent = "We couldn’t remove that item. Please try again.";
            remove.disabled = false;
          }
        });
        content.append(title, visit, remove);
        item.append(content);
        entriesRoot.append(item);
      });
    } catch {
      status.textContent = "We couldn’t load your Wish List. Please try again.";
    }
  };

  document.querySelectorAll("[data-storitime-header-wishlist]").forEach((trigger) => {
    trigger.addEventListener("click", () => void showWishlist(trigger));
  });
  document.addEventListener("storitime:wishlist:open", (event) => {
    void showWishlist(event.detail?.trigger || document.activeElement);
  });
  close?.addEventListener("click", () => dialog.close());
  dialog.addEventListener("close", () => returnFocus?.focus());
})();
